// Recovered compiled webpack factory 67269. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.r(t);
  const noop = () => {};
  a.d(t, { onRouterTransitionStart: () => noop });
}
